import { useSelector } from 'react-redux';
import { Alert, Button, notification } from 'antd';
import qs from 'qs';
import { useEffect, useState } from 'react';
import { RootState } from '../../modules';
import { RouteComponentProps } from 'react-router-dom';
import {
  connectToModusign,
  disconnectToModusign,
  registerUserToModusign,
} from '../../api/constlink';
import ConnectToModusignModal from '../../components/profiles/ConnectToModusignModal';
import ProfileDetailComponent from '../../components/profiles/ProfileDetailComponent';

function ProfileDetailContainer({ history, match }: RouteComponentProps) {
  const [visible, setVisible] = useState<boolean>(false);
  const [content, setContent] = useState<any>({
    title: '',
    description: '',
    btnName: '',
    isUserRegistered: false,
  });
  const [visibleModusignAlert, setVisibleModusignAlert] =
    useState<boolean>(false);
  const data = useSelector((state: RootState) => state.auth.auth.data);
  // const goSignaturePadPage = () => {
  //   console.log('goSignaturePadPage');
  //   history.push('profile/sig-pad');
  // };

  useEffect(() => {
    const { reqConnectModusign } = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    });
    if (reqConnectModusign) setVisibleModusignAlert(true);
  }, []);

  const goMainPage = () => {
    history.push('main');
  };
  const goEditPage = () => {
    history.push(`profile/edit`);
  };

  const _connectToModusign = async () => {
    const res = await connectToModusign({});

    if (res.isUserRegistered) {
      setContent({
        title: '모두싸인 연결하기',
        description: '아래 버튼을 클릭하여 모두싸인에 연결 하세요.',
        btnName: '모두싸인 연결하기',
        isUserRegistered: res.isUserRegistered,
      });
    } else {
      setContent({
        title: '모두싸인 회원가입 후 연결하기',
        description:
          '아래 버튼을 클릭하여 모두싸인에 회원가입 하세요. 회원가입 후 모두싸인 연결 페이지로 이동 합니다.',
        btnName: '모두싸인 회원가입 & 연결하기',
        isUserRegistered: res.isUserRegistered,
      });
    }

    setVisible(true);
  };

  const _disconnectToModusign = async () => {
    await disconnectToModusign({});
    notification.open({ message: '모두싸인과 연결이 끊어졌습니다.' });
  };

  const _registerUserToModusign = async () => {
    if (data === null) {
      notification.open({ message: '내 계정 정보가 잘못 되었습니다.' });
      return;
    }
    await registerUserToModusign({
      data: {
        name: data.name,
        email: data.email,
      },
    });
    notification.open({
      message: `${data.name}님의 ${data.email} 계정으로 모두싸인 회원가입을 요청 하였습니다. 요청 메일을 확인 해 주세요.`,
    });
    setVisible(false);
  };

  const onCancel = () => {
    setVisible(false);
  };

  const goPasswordResetPage = () => {
    history.push(`profile/reset-password`);
  };

  const deleteUserAccount = () => {
    history.push(`profile/delete`);
  };

  const updateUserPhone = () => {
    history.push(`profile/update-user-phone`);
  };
  return (
    <>
      {visibleModusignAlert && (
        <Alert
          message="모두싸인 연결 요청"
          showIcon
          description="전자 계약 기능을 이용하려면 모두싸인과 연결해야 합니다."
          type="warning"
          action={
            <Button onClick={_connectToModusign}>모두싸인 연결하기</Button>
          }
        />
      )}
      {data && (
        <ProfileDetailComponent
          data={data}
          // goSignaturePadPage={goSignaturePadPage}
          goMainPage={goMainPage}
          goEditPage={goEditPage}
          goPasswordResetPage={goPasswordResetPage}
          deleteUserAccount={deleteUserAccount}
          updateUserPhone={updateUserPhone}
          connectToModusign={_connectToModusign}
          disconnectToModusign={_disconnectToModusign}
        />
      )}
      {data && (
        <ConnectToModusignModal
          visible={visible}
          content={content}
          userEmail={data.email}
          registerUserToModusign={_registerUserToModusign}
          onCancel={onCancel}
        />
      )}
    </>
  );
}

export default ProfileDetailContainer;
